import { Outlet } from "react-router-dom";
import styles from "../../assets/scss/Layouts.module.scss";
import Header from "./Header";
import { useDashboardDataContext } from "./../context/dashboardDataContext";


const Layouts = () => {
     const { navbarFixed } = useDashboardDataContext();

    return (
        <div className={styles.layout}>
            <Header />
            <div
                className={`${styles.content} p-3 w-100`}
                style={{
                    marginTop: `${navbarFixed ? "150px" : "0"}`,
                    minHeight:'calc(100vh - 130px)'
                }}
            >
               <div style={{ paddingTop: "120px" }}>
                    <Outlet />
                    </div>
            </div>
        </div>
    );
};

export default Layouts;

